import { useQuery } from 'react-query';
import { identifyUser } from '@kcd/event-tracker';

import { BUYER_QUERY_KEY } from '~/api/query-keys';

export function useCurrentUser() {
  const { data: user, ...props } = useQuery({
    ...BUYER_QUERY_KEY.current(),
    suspense: false,
    keepPreviousData: true,
    onSuccess: (data) => {
      if (data) {
        identifyUser(data.trackingId as string, {
          name: data.name,
          publicUserId: data.uuid,
        });
      }
    },
  });

  return {
    ...props,
    user,
  };
}
